exports.f = Object.getOwnPropertySymbols;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_object-gops.js
// module id = 1495
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 13 14 15 16